module.exports = "/virtual-football-league/img/amblems/right/logos/ATLETICO MADRID.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/ATLETICO MADRID.png
// module id = 2154
// module chunks = 4